import React from "react";
import { IAcademicsMenuCoursesData } from "../../exports/interfaces";
import { Link } from "react-router-dom";

const CourseContent = ({
  // program,
  // course,
  selectedCourse,
}: {
  // program: string;
  // course: string;
  selectedCourse: IAcademicsMenuCoursesData | null;
}) => {
  return (
    <div
      className="col-lg-9 wow fadeInUp course-container-border"
      data-wow-duration="1s"
      data-wow-delay="0.3s"
    >
      <div className="td_section_heading td_style_1 td_mb_30">
        {/* <p
          className="td_section_subtitle_up td_fs_18 td_spacing_1 td_mb_10 td_accent_color"
          style={{ textAlign: "unset" }}
        >
          SAST | Undergraduate Programs | {program}
        </p>
        <h2 className="td_section_title td_fs_48">{course}</h2> */}
        <p
          className="td_section_subtitle td_fs_18 mb-0 mt-0"
          dangerouslySetInnerHTML={{
            __html: selectedCourse?.description || "",
          }}
        />
        <p
          className="td_section_subtitle td_fs_18 mb-0"
          dangerouslySetInnerHTML={{
            __html: selectedCourse?.distinctive_features || "",
          }}
        />
        <p
          className="td_section_subtitle td_fs_18 mb-0"
          dangerouslySetInnerHTML={{
            __html: selectedCourse?.subjects || "",
          }}
        />
        <p
          className="td_section_subtitle td_fs_18 mb-0"
          dangerouslySetInnerHTML={{
            __html: selectedCourse?.path_forward || "",
          }}
        />
        <Link
          to="/application-form"
          className="td_btn td_style_1 td_radius_10 td_medium"
        >
          <span className="td_btn_in td_white_color td_orange_bg">
            <span>Apply Now</span>
            <svg
              width="19"
              height="20"
              viewBox="0 0 19 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15.1575 4.34302L3.84375 15.6567"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M15.157 11.4142C15.157 11.4142 16.0887 5.2748 15.157 4.34311C14.2253 3.41142 8.08594 4.34314 8.08594 4.34314"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
        </Link>
      </div>
    </div>
  );
};

export default CourseContent;
